/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusEmailProtokollListResponseDto } from '../../models/lexplus-email-protokoll-list-response-dto';

export interface EmailProtokollControllerFindAllPaginatedV1$Params {

/**
 * Page number to retrieve. If you provide invalid value the default page number will applied
 *
 * **Example:** 1
 *
 *
 * **Default Value:** 1
 */
  page?: number;

/**
 * Number of records per page.
 *
 *
 * **Example:** 20
 *
 *
 *
 * **Default Value:** 25
 *
 *
 *
 * **Max Value:** 100
 *
 *
 * If provided value is greater than max value, max value will be applied.
 */
  limit?: number;

/**
 * Filter by erstelltAm query param.
 *
 * **Format:** filter.erstelltAm={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.erstelltAm=$gte:John Doe&filter.erstelltAm=$lt:John Doe
 *
 * **Available Operations**
 * - $gte
 *
 * - $lt
 *
 * - $and
 *
 * - $or
 */
  'filter.erstelltAm'?: Array<string>;

/**
 * Filter by status query param.
 *
 * **Format:** filter.status={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.status=$eq:John Doe&filter.status=$in:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $in
 *
 * - $and
 *
 * - $or
 */
  'filter.status'?: Array<string>;

/**
 * Filter by benachrichtigungstyp query param.
 *
 * **Format:** filter.benachrichtigungstyp={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.benachrichtigungstyp=$eq:John Doe&filter.benachrichtigungstyp=$in:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $in
 *
 * - $and
 *
 * - $or
 */
  'filter.benachrichtigungstyp'?: Array<string>;

/**
 * Filter by umgeleitet query param.
 *
 * **Format:** filter.umgeleitet={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.umgeleitet=$eq:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $and
 *
 * - $or
 */
  'filter.umgeleitet'?: Array<string>;

/**
 * Parameter to sort by.
 * To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting
 *
 * **Format:** {fieldName}:{DIRECTION}
 *
 *
 * **Example:** sortBy=erstelltAm:DESC&sortBy=emailProtokollID:DESC
 *
 *
 * **Default Value:** erstelltAm:DESC
 *
 * **Available Fields**
 * - erstelltAm
 *
 * - emailProtokollID
 */
  sortBy?: Array<'erstelltAm:ASC' | 'erstelltAm:DESC' | 'emailProtokollID:ASC' | 'emailProtokollID:DESC'>;

/**
 * Search term to filter result values
 *
 * **Example:** John
 *
 *
 * **Default Value:** No default value
 */
  search?: string;

/**
 * List of fields to search by term to filter result values
 *
 * **Example:** empfaenger,tatsaechlicheEmpfaenger,betreff
 *
 *
 * **Default Value:** By default all fields mentioned below will be used to search by term
 *
 * **Available Fields**
 * - empfaenger
 *
 * - tatsaechlicheEmpfaenger
 *
 * - betreff
 */
  searchBy?: Array<string>;
}

export function emailProtokollControllerFindAllPaginatedV1(http: HttpClient, rootUrl: string, params?: EmailProtokollControllerFindAllPaginatedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusEmailProtokollListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, emailProtokollControllerFindAllPaginatedV1.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('filter.erstelltAm', params['filter.erstelltAm'], {});
    rb.query('filter.status', params['filter.status'], {});
    rb.query('filter.benachrichtigungstyp', params['filter.benachrichtigungstyp'], {});
    rb.query('filter.umgeleitet', params['filter.umgeleitet'], {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('search', params.search, {});
    rb.query('searchBy', params.searchBy, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusEmailProtokollListResponseDto>;
    })
  );
}

emailProtokollControllerFindAllPaginatedV1.PATH = '/v1/email-protokoll/paginated';
